import { render, staticRenderFns } from "./VTimeField.vue?vue&type=template&id=5c536424&scoped=true&"
import script from "./VTimeField.vue?vue&type=script&lang=js&"
export * from "./VTimeField.vue?vue&type=script&lang=js&"
import style0 from "./VTimeField.vue?vue&type=style&index=0&id=5c536424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c536424",
  null
  
)

export default component.exports